export const PRIZES = [
  {
    id: "first",
    place: "1st Place",
    amount: "$2,000",
    currency: "USD",
    accent: "gold",
  },
  {
    id: "second",
    place: "2nd Place",
    amount: "$1,000",
    currency: "USD",
    accent: "silver",
  },
  {
    id: "third",
    place: "3rd Place",
    amount: "$500",
    currency: "USD",
    accent: "bronze",
  },
  {
    id: "fourth",
    place: "4th Place",
    amount: "$400",
    currency: "USD",
    accent: "blue",
  },
  {
    id: "fifth",
    place: "5th Place",
    amount: "$300",
    currency: "USD",
    accent: "purple",
  },
  {
    id: "sixth",
    place: "6th Place",
    amount: "$200",
    currency: "USD",
    accent: "green",
  },
  {
    id: "seventh",
    place: "7th Place",
    amount: "$100",
    currency: "USD",
    accent: "red",
  },
];
